import React from "react";
import { MenuContentPiece, MenuComponentProps } from "./Pieces";
export default function MenuComponent(props: MenuComponentProps) {
  return <MenuContentPiece {...props} />;
}
